export const SITE: SiteMeta = {
	basePathname: '/',
	blogPageURL: new URL('', 'https://blog.cityflo.com/'),
	LUXEPageURL: new URL('', 'https://luxe.cityflo.com/'),
	careersPageURL: new URL('', 'https://careers.cityflo.com/'),
	facebookDomainVerificationId: '7zxa2bzis8fu9zqxmenp7dr32pkmu8',
	googleAnalyticsId: 'G-1V08C2NKH2', // or "G-XXXXXXXXXX",
	// googleAnalyticsId: 'UA-66907811-2', // or "G-XXXXXXXXXX",
	googleSiteVerificationId: 'Eqc-mItQlG51E8vDxo0pDng8bzKM_SPn_3poCsTOoe0',
	name: 'Cityflo',
	origin: import.meta.env.PUBLIC_BASE_WWW_URL,
	splitbeeAnalytics: true,
};

export const CorporateMeta: PageMeta = {
	canonical: new URL('/corporate/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description:
		'Save up to 40% on your corporate transport costs with our flexible pay-per-seat model. An effective, comfortable option where you pay only for the rides employees take, rather than spending on dedicated company buses or reimbursing expensive cab fares or high parking costs.',
	title: 'Cityflo Corporate | Affordable Employee Transport',
};

export const RentalsMeta: PageMeta = {
	canonical: new URL('/rentals/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description:
		'Cityflo is a bus rentals company in Mumbai that offers a range of traveller buses, mini buses and luxury coaches on rent.',
	title: 'Cityflo Rentals | Book traveller buses on rent in Mumbai',
};

export const IndexMeta: PageMeta = {
	canonical: new URL('/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description:
		'Cityflo is an app-based daily commute service that provides stress-free office rides in premium buses currently operating in Mumbai, Thane & Hyderabad.',
	title: 'Cityflo: App-based AC buses for office commute',
};

export const TermsAndConditionsMeta: PageMeta = {
	canonical: new URL('terms-and-conditions/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description: 'Cityflo Terms & Conditions',
	title: 'Terms & Conditions',
};

export const PrivacyPolicyMeta: PageMeta = {
	canonical: new URL('privacy-policy/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description: 'Cityflo Privacy Policy',
	title: 'Privacy Policy',
};

export const RefundsAndCancellationMeta: PageMeta = {
	canonical: new URL('refunds-and-cancellation-policy/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description: 'Cityflo Refunds and Cancellation Policy',
	title: 'Refunds and Cancellation Policy',
};

export const CustomerGuidelinesMeta: PageMeta = {
	canonical: new URL('customer-guidelines/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description: 'Cityflo Customer Guidelines',
	title: 'Customer Guidelines',
};

export const SubscriptionPolicyMeta: PageMeta = {
	canonical: new URL('subscription-policy/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description: 'Cityflo Subscription Policy',
	title: 'Subscription Policy',
};

export const FlexiPassPolicyMeta: PageMeta = {
	canonical: new URL('flexi-pass-policy/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description: 'Cityflo Flexi Pass Policy',
	title: 'Flexi Pass Policy',
};

export const FAQsMeta: PageMeta = {
	canonical: new URL('faqs/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description: 'FAQs for Cityflo',
	title: 'FAQS',
};

export const RouteMapMumbaiMeta: PageMeta = {
	canonical: new URL('/route-map/mumbai/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description: 'Find out your nearest stop on our route map',
	image: new URL('/route-map/mumbai_route_map.png', SITE.origin),
	title: 'Cityflo Route Map Mumbai',
};

export const RouteMapHyderabadMeta: PageMeta = {
	canonical: new URL('/route-map/hyderabad/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description: 'Find out your nearest stop on our route map',
	image: new URL('/route-map/hyderabad_route_map.png', SITE.origin),
	title: 'Cityflo Route Map Hyderabad',
};

export const RouteMapDelhiMeta: PageMeta = {
	canonical: new URL('/route-map/delhi/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description: 'Find out your nearest stop on our route map',
	image: new URL('/route-map/delhi_route_map.png', SITE.origin),
	title: 'Cityflo Route Map Delhi',
};

export const RouteExplorationMumbaiMeta: PageMeta = {
	canonical: new URL('/routes/mumbai/', SITE.origin),
	downloadAppLink: new URL('', 'https://m.cityflo.com/NpzM/4z1elkvq'),
	description: 'Find out your nearest route on our route map',
	title: 'Cityflo Routes | Mumbai',
};

export const RouteExplorationHyderabadMeta: PageMeta = {
	canonical: new URL('/routes/hyderabad/', SITE.origin),
	downloadAppLink: new URL('', 'https://m.cityflo.com/NpzM/4z1elkvq'),
	description: 'Find out your nearest route on our route map',
	title: 'Cityflo Routes | Hyderabad',
};

export const RouteExplorationDelhidMeta: PageMeta = {
	canonical: new URL('/routes/delhi/', SITE.origin),
	downloadAppLink: new URL('', 'https://m.cityflo.com/NpzM/4z1elkvq'),
	description: 'Find out your nearest route on our route map',
	title: 'Cityflo Routes | Delhi',
};

export const RouteMeta: PageMeta = {
	canonical: new URL('', SITE.origin),
	downloadAppLink: new URL('', 'https://m.cityflo.com/NpzM/4z1elkvq'),
};

export const Error404Meta: PageMeta = {
	canonical: new URL('/404/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description: 'Page not found',
	title: `Error 404 — ${SITE.name}`,
};

// TODO:
export const AdsMeta: PageMeta = {
	canonical: new URL('/corporate/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description: '',
	title: 'Cityflo Ads Suite | Affordable Employee Transport',
};

export const AdsCampaignMeta: PageMeta = {
	canonical: new URL('', SITE.origin),
	downloadAppLink: new URL('', 'https://m.cityflo.com/NpzM/4z1elkvq'),
};

export const CampaignConsent: PageMeta = {
	canonical: new URL('/campaign/consent/', SITE.origin),
	downloadAppLink: new URL('', 'https://cityfloapp.onelink.me/NpzM/85d5f4dc'),
	description: 'Consent form for Cityflo campaigns',
	title: 'Cityflo Campaigns | Consent',
};

export const citiesList = [
	{
		params: {
			city: 'mumbai',
		},
		props: {
			alt: 'Mumbai Route Map',
			meta: RouteMapMumbaiMeta,
			id: 2,
		},
	},
	{
		params: {
			city: 'hyderabad',
		},
		props: {
			alt: 'Hyderabad Route Map',
			meta: RouteMapHyderabadMeta,
			id: 6,
		},
	},
	{
		params: {
			city: 'Delhi',
		},
		props: {
			alt: 'Delhi Route Map',
			meta: RouteMapDelhiMeta,
			id: 5,
		},
	},
];

export const citiesListRouteExploration = [
	{
		params: {
			city: 'mumbai',
		},
		props: {
			alt: 'Mumbai Route Map',
			meta: RouteExplorationMumbaiMeta,
			id: 2,
		},
	},
	{
		params: {
			city: 'hyderabad',
		},
		props: {
			alt: 'Hyderabad Route Map',
			meta: RouteExplorationHyderabadMeta,
			id: 6,
		},
	},
	{
		params: {
			city: 'delhi',
		},
		props: {
			alt: 'Delhi Route Map',
			meta: RouteExplorationDelhidMeta,
			id: 5,
		},
	},
];

export const homePageDownloadCTALink = 'https://m.cityflo.com/NpzM/inf7dhvw';
